<template>
  <div class="extra-stats-table-container">
    <h3>Stats:</h3>
    <div class="stats-mode">
      <span>
        Currently displaying for <b>{{ mimirMode ? "Mimir" : "L & D" }}</b>
      </span>
      <button @click="switchMode" class="switch-button">Switch</button>
    </div>
    <div class="table-container">
      <table>
        <tr>
          <th>{{ "Player/Team" }}</th>
          <th v-for="(col, i2) in getColumns" :key="i2">
            {{ col.label }}
          </th>
        </tr>
        <tr v-for="(row, i1) in newTable" :key="i1">
          <td>{{ getPlayers[i1].name }}</td>
          <td v-for="(col, i2) in getColumns" :key="i2">
            <span v-if="col.label === 'O'">
              {{ `${row.ownCorrect}/${row.ownAttempt}` }}
            </span>
            <span v-else-if="col.field === 'adjusted'" class="make-bold">
              {{ getAdjustedScore(row.spread, numPlayers) }}
            </span>
            <span v-else>
              {{ row[col.field] }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ExtraStatsTable",
  data() {
    return {
      newTable: [],
      columns: [
        { label: "BA", field: "bonusAttempt", display: false },
        { label: "O", field: "ownCorrect", display: false },
        { label: "BP", field: "bonusPoint", display: false },
        { label: "X", field: "notAnswered", display: false },
        { label: "Points", field: "point", display: true },
        { label: "Spread", field: "spread", display: true },
        { label: "Adjusted", field: "adjusted", display: true },
      ],
      mimirMode: true, //if false, then Lob & Dunk mode
    };
  },
  mounted() {
    this.newTable = this.buildTable(
      this.gamePlayString,
      this.numRounds,
      this.numPlayers,
      this.numDirects
    );
  },
  computed: {
    ...mapState(["gamePlayString", "numPlayers", "numRounds", "numDirects"]),
    ...mapGetters(["getPlayers"]),
    getColumns() {
      return this.columns.filter((c) => c.display);
    },
  },
  methods: {
    switchMode() {
      this.mimirMode = !this.mimirMode;
    },

    getAdjustedScore(s, p) {
      let value = 1;
      let score = 0;
      const increment = this.mimirMode ? 1 / (p - 1) : -0.5 / (p - 1);
      for (var i = 0; i < s.length; i++) {
        score += s[i] * value;
        value += increment;
      }

      return score.toFixed(2);
    },
    buildTable(gps, nr, np, nd) {
      gps, nr, nd;
      var template = {
        point: 0,
        bonusAttempt: 0,
        ownCorrect: 0,
        ownAttempt: 0,
        bonusPoint: 0,
        notAnswered: 0,
        spread: [],
      };
      const table = [];

      let questionNo = 0;
      let pointer = 0;
      let passOrder = [];

      for (var i = 0; i < np; i++) {
        template.spread = [...new Array(np).fill(0)];
        table.push(Object.assign({}, template));
      }

      const getPassOrder = (sequence, p) => {
        const wrap = sequence.slice(p + 1).concat(sequence.slice(0, p));
        wrap.sort((a, b) => a[1] - b[1]);
        return [sequence[p][0], ...wrap.map((x) => x[0])];
      };

      [...gps].forEach((action) => {
        const direct = parseInt(
          (questionNo % (this.numPlayers * this.numDirects)) / this.numDirects
        );

        if (pointer === 0) {
          passOrder = getPassOrder(
            table.map((x, i) => [i, x.bonusAttempt]),
            direct
          );
        }

        const currentSeat = passOrder[pointer];

        if (action === "C") {
          table[currentSeat].point += 1;
          table[currentSeat].spread[pointer] += 1;
          if (pointer === 0) {
            table[currentSeat].ownCorrect += 1;
            table[currentSeat].ownAttempt += 1;
          } else {
            table[currentSeat].bonusPoint += 1;
            table[currentSeat].bonusAttempt += 1;
          }
          questionNo += 1;
          pointer = 0;
        }

        if (action === "W") {
          if (pointer > 0) {
            table[currentSeat].bonusAttempt += 1;
          } else {
            table[currentSeat].ownAttempt += 1;
          }
          pointer += 1;
          if (pointer === this.numPlayers) {
            table[direct].notAnswered += 1;
            pointer = 0;
            questionNo += 1;
          }
        }

        if (action === "P") {
          if (pointer === 0) {
            table[currentSeat].ownAttempt += 1;
          }
          pointer += 1;
          if (pointer === this.numPlayers) {
            table[direct].notAnswered += 1;
            pointer = 0;
            questionNo += 1;
          }
        }

        if (action === "K") {
          table[direct].notAnswered += 1;
          if (pointer === 0) {
            table[currentSeat].ownAttempt += 1;
          }
        }
      });

      return table;
    },
  },
};
</script>

<style scoped>
table {
  margin: 10px auto;
  width: 60%;
}

td,
th {
  font-size: 26px;
}

th {
  background-color: #d7d7d7;
}

.make-bold {
  font-weight: bold;
}

.switch-button {
  margin-left: 30px;
  cursor: pointer;
  background-color: lightgrey;
  border: none;
  border-radius: 10px;
  padding: 10px;
}

.switch-button:hover {
  background-color: rgb(175, 175, 175);
}
</style>